import { describeArc, calculateAngleFromPercent } from './math';

export function animateGauge(startPercent, stopPercent, grayFillElement, pointerElement) {

    if(!grayFillElement) {
        return;
    }
    grayFillElement.style.display = 'block';
    const diff = stopPercent - startPercent;
    // in ms
    const time_constrain = 1000;

    const time_interval = time_constrain/diff;
    let start_value = startPercent;

    let intervalID = setInterval(function() {
        const calculatedAngle = calculateAngleFromPercent(start_value);
        grayFillElement.setAttribute("d", describeArc(70, 70, 60, calculatedAngle, 140));
        animatePointer(pointerElement, calculatedAngle);
        start_value++;
        if(start_value > (stopPercent - 1)) {
            clearInterval(intervalID);
            hideFullCircle(grayFillElement, start_value);
        }
    }, time_interval);
}

function hideFullCircle(element, start_value) {
    if(start_value > 99) {
        element.style.display = 'none';
    }
};

function animatePointer(pointerElement, angle) {
    pointerElement.setAttribute('transform',`rotate(${angle},70,70)`);
}
